/**
 * ForecastCashflowPrint — page « Cash flow » du Prévisionnel (4ᵉ onglet).
 * Réutilise le COMPOSANT RÉEL de l'écran (ForecastCashflowTab) : cash flow
 * prévisionnel méthode indirecte depuis le résultat net → trésorerie. Hypothèses
 * BFRE + cash flow lues EN BASE (même hook que le hub). `onReady` one-shot.
 */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ForecastCashflowTab from '../ForecastCashflowTab';
import { usePersistentValue } from '../../hooks/usePersistentState';
import { useForecastAssumptions } from '../../hooks/useForecastAssumptions';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

const noop = () => {};

export default function ForecastCashflowPrint({ activeTenant, year, editedAt, onDataReady }) {
  const { t } = useTranslation();
  const tid = activeTenant?.id;
  const [unit] = usePersistentValue(`prev_unit_${tid}`, 'kchf');
  const { a, loading: aLoading } = useForecastAssumptions(tid, year);
  const assumptions = { dso: a.dso, dpo: a.dpo, dio: a.dio, pac: a.pac, setDso: noop, setDpo: noop, setDio: noop, setPac: noop };
  const cashflow = { invLines: a.cf_inv, finLines: a.cf_fin, setInvLines: noop, setFinLines: noop };
  const done = useRef(false);
  const ready = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('forecast-cash'); } };

  if (aLoading) return <div className="ppl-print__section"><p>Chargement…</p></div>;

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint fin-print-forecast-bfre">
      <PrintReportHeader category={t('phrases:p_6ac06e4cde')} title={t('phrases:p_96e08a3b9f')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <ForecastCashflowTab activeTenant={activeTenant} year={year} assumptions={assumptions} cashflow={cashflow} unit={unit} onReady={ready} />
    </section>
  );
}
